var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publicModule-container"},[_c('div',{staticClass:"publicModule-head"},[_c('p',{staticClass:"publicModule-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"publicModule-label"},[_vm._v(_vm._s(_vm.lable))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }